import {
  thresholdTypeOptions,
  ThresholdType,
} from '../types/pie-chart.config.js';

/**
 * Returns true is thresholdType  is a valid ThresholdType
 * @param thresholdType - threshold type
 */
export const isValidThresholdType = (
  thresholdType: ThresholdType,
): thresholdType is ThresholdType =>
  thresholdTypeOptions.includes(thresholdType);
